class BarBus {
  constructor () {
    this.store = {
      'routerChange': [],
      'routerBack': [],
      'directlyEnter': []
    }
  }

  $on (event, handler) {
    if (!this.store[event]) {
      this.store[event] = []
    }

    this.store[event].push(handler)
  }

  $emit (event, ...args) {
    if (!this.store[event]) {
      return console.error('[BarBus] 尚未注册的事件')
    }

    this.store[event].forEach(item => item(...args))
  }
}

export default new BarBus()
